import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function Summary({ children }) {
  return (
    <Stack as={Text} color="primary" size="sm">
      {children}
    </Stack>
  );
}

Summary.propTypes = {
  children: PropTypes.node.isRequired
};

export default Summary;
